import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  footer: {
    width: '100%',
    padding: `${styles.spacing(4)}px 0`,
    background: styles.palette.background.dark,
    color: styles.palette.text.inverse,
    lineHeight: 1.5 + '!important',
    fontSize: '16px',
    fontFamily: styles.fonts.primary,
    fontWeight: 300,
  },
  container: {
    padding: `0 ${styles.spacing(8)}px`,
    transition: styles.transitions.regular(['padding']),
    [styles.breakpoints.down('lg')]: {
      padding: `0 ${styles.spacing(5)}px`,
    },
    [styles.breakpoints.down('md')]: {
      padding: `0 ${styles.spacing(4)}px`,
    },
  },
  topLine: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [styles.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contacts: {
    paddingRight: `${styles.spacing(4)}px`,
    [styles.breakpoints.down('sm')]: {
      paddingRight: 0,
      marginBottom: `${styles.spacing(4)}px`,
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 400,
    marginBottom: `${styles.spacing(1)}px`,
  },
  info: {
    fontSize: '16px',
  },
  divider: {
    margin: '2rem 0',
  },
  disclaimer: {
    fontWeight: 300 + '!important',
    fontSize: '15px',
  },
  richText: {
    '& p, & h4, & h5, & h6': {
      marginBottom: `${styles.spacing(2)}px`,
    },
    '& a': {
      color: styles.palette.text.inverse,
      textDecoration: 'none',
      opacity: 0.8,
      fontWeight: 300 + '!important',
      transition: styles.transitions.regular(['color']),
      '&:hover': {
        color: styles.palette.text.secondaryDark,
      },
      '&:focus, &:active': {
        color: styles.palette.text.secondaryIntensive,
      },
    },
  },
});
